import { Countries } from "types/Models/countries";
import { getIsStateRequired } from "utils/stateRequired";
import { object, string } from "yup";

export const personaAutofill = object({
  first_name: string().min(1, "Min. 1 character").required("Required"),
  last_name: string().required("Required"),
  email: string().email("Should be a valid email").nullable(),
  citizenship: string().nullable().required("Required"),
});

export const addressAutofill = (countries: Countries[] = []) =>
  object({
    street_address: string().required("Address Line 1 Required"),
    city: string().required("City Required"),
    country: string().required("Country Required"),
    state: string().when("country", {
      is: (country: string) => getIsStateRequired(countries, country),
      then: string().required("State Required"),
      otherwise: string().notRequired(),
    }),
    zipcode: string().required("Required"),
  });

export const bankAutofill = object({
  account_number: string().required("Account Number Required"),
  entity_id: string().required("Please select entity"),
});

export const personaAutoFillSalesTax = object({
  first_name: string().nullable().required("Required"),
  last_name: string().nullable().required("Required"),
  email: string().nullable().required("Required"),
  appointed_on: string().nullable().required("Required"),
  job_title: string().nullable().required("Required"),
  phone_number: string().nullable().required("Required"),
  date_of_birth: string()?.nullable(),
  tax_id: string().nullable().required("Required"),
  address_id: string().nullable().required("Required"),
  citizenship: string().nullable().required("Required"),
});
